export default __webpack_public_path__ + "static/B0056-7beefd6e12861cdb81e42f2e54dbaba5.png";